// extracted by mini-css-extract-plugin
export default {"label":"label_wckit","left":"left_VsSDH","center":"center_jvL_t","right":"right_PFdNd","ellipsis":"ellipsis_qk7qd"};